<div class="filter">
  <fa-icon [icon]="getFaIcon('faFilter')" (click)="showFilter(idFilter, column ); $event.stopPropagation()" appChangeColorTheme attribute="color"></fa-icon>
  <app-admin-filter-table [id]="idFilter" [idFilter]="idFilter" [column]="column" >
  </app-admin-filter-table>
</div>
